import { render, staticRenderFns } from "./CellBalanceDetailView.vue?vue&type=template&id=3b4178b0"
import script from "./CellBalanceDetailView.vue?vue&type=script&lang=js"
export * from "./CellBalanceDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports